import { graphql } from '../../gql';

export const CUSTOM_ROLE_TAXONOMY_QUERY = graphql(`
  query CustomRoleTaxonomy($taxonomyId: CustomRoleTaxonomySelection!) {
    selectionList {
      role_taxonomy_k10(taxonomy_id: $taxonomyId) {
        id
        shortName
        longName
        rawTitles
      }
      role_taxonomy_k50(taxonomy_id: $taxonomyId) {
        id
        shortName
        longName
        job_category: role_k10
        role_k10
        rawTitles
      }
      role_taxonomy_k150(taxonomy_id: $taxonomyId) {
        id
        shortName
        longName
        job_category: role_k10
        role_k10
        role_k50
        rawTitles
      }
      role_taxonomy_k500(taxonomy_id: $taxonomyId) {
        id
        shortName
        longName
        job_category: role_k10
        role_k10
        role_k50
        role_k150
        rawTitles
      }
      role_taxonomy_k1500(taxonomy_id: $taxonomyId) {
        id
        shortName
        longName
        job_category: role_k10
        role_k10
        role_k50
        role_k150
        role_k500
        rawTitles
      }
      role_taxonomy_k5000(taxonomy_id: $taxonomyId) {
        id
        shortName
        longName
        job_category: role_k10
        role_k10
        role_k50
        role_k150
        role_k500
        role_k1500
        rawTitles
      }
      role_taxonomy_k15000(taxonomy_id: $taxonomyId) {
        id
        shortName
        longName
        job_category: role_k10
        role_k10
        role_k50
        role_k150
        role_k500
        role_k1500
        role_k5000
        rawTitles
      }
    }
  }
`);
